export const AUTH_REQUEST = 'authentication_request'
export const AUTH_LOGOUT = 'authentication_logout'
export const AUTH_SUCCESS = 'authentication_success'
export const AUTH_ERROR = 'authentication_error'
export const AUTH_REFRESH = 'authentication_refresh'

export const ERROR = 'error'
export const SUCCESS = 'success'
export const CLEAN_ALERT = 'clean_alert'

export const OPEN_MODAL = 'open_modal'
export const CLOSE_MODAL = 'close_modal'

export const GET_USER = 'get_user'
export const SET_USER = 'set_user'

export const SET_SUBBOT = 'set_subbot'
export const SET_BOT = 'set_bot'
export const SET_USER_LISTS = 'set_users_lists'
export const SET_USER_GROUPS = 'set_users_groups'

export const themes = [
	'Castration chat',
	'Stérilisation chatte',
	'Stérilisation chienne',
	'Castration chien',
	'Bilan Sénior',
	'Bilan Sénior N2',
	'Relance vaccin clients inactifs',
	'Post hospitalisation',
	'Chirurgie Orthopédique',
	'Post consultation satisfaction',
	'Post consultation satisfaction N2',
	'Enquête',
	'Post Chirurgie',
	'BI Arthrose',
	'BI Diabète',
	'BI Hypertension',
	'BI Hyperthyroïdie',
	'BI MRC',
	'Diabète',
	'Hypertension artérielle',
	'Hyperthyroïdie',
	'Maladie Rénale Chronique',
]

export const dateByTheme = {
	'Castration chat': 'dateSterilisation',
	'Stérilisation chatte': 'dateSterilisation',
	'Stérilisation chienne': 'dateSterilisation',
	'Castration chien': 'dateSterilisation',
	'Bilan Sénior': 'date_prochaine_vaccination_bil_senior',
	'Bilan Sénior N2': 'date_prochaine_vaccination_bil_senior_n2',
	'Relance vaccin clients inactifs': 'date_vaccin_visite_annuelle_client_inact_vaccin',
	'Post hospitalisation': 'date_sortie_post_hospit',
	'Chirurgie Orthopédique': 'date_ope_chir_ortho',
	'Post consultation satisfaction': 'date_post_consult_satis',
	'Post consultation satisfaction N2': 'date_post_consult_satis_n2',
	Enquête: 'date_derniere_consult_enquete',
	'Post Chirurgie': 'date_sortie_post_chir',
	'BI Arthrose': 'date_bi_maladie_silencieuse_ct',
	'BI Diabète': 'date_bi_maladie_silencieuse_ct',
	'BI Hypertension': 'date_bi_maladie_silencieuse_ct',
	'BI Hyperthyroïdie': 'date_bi_maladie_silencieuse_ct',
	'BI MRC': 'date_bi_maladie_silencieuse_ct',
	Diabète: 'date_diagnostic_patho_chroniques',
	'Hypertension artérielle': 'date_diagnostic_patho_chroniques',
	Hyperthyroïdie: 'date_diagnostic_patho_chroniques',
	'Maladie Rénale Chronique': 'date_diagnostic_patho_chroniques',
}
export const themeDates = [...new Set(Object.keys(dateByTheme).map((theme) => dateByTheme[theme]))]
export const dateVariables = [...themeDates]

export const usableDates = dateVariables.map((d) => `{${d}}`).join(' ')
export const regexpDates = new RegExp(`{(${dateVariables.join('|')})}`, 'g')
export const isDateKey = (key) => !!dateVariables.find((dateKey) => dateKey === key)
export const isThemeDateKey = (key) => !!themeDates.find((dateKey) => dateKey === key)

export const getMessageHint = (isAsko) => {
	return `${isAsko ? `{nomAnimal} {espece} ${usableDates}` : ''}{prenom} {nom} {mail} seront remplacé par les données
				de l'utilisateur.
				Pour faire une condition : {if 'valeur'}{else}{endif} ou {if 'valeur'}{endif} ou valeur peut être tu,vous,M, F${
					isAsko ? ', chien, chienne, chat, chatte, animalM, animalF' : ''
				}`
}



// WEBPACK FOOTER //
// ./src/variables.js